import { render, staticRenderFns } from "./JWBOrderEntitiesDetails.vue?vue&type=template&id=257865bd"
import script from "./JWBOrderEntitiesDetails.vue?vue&type=script&lang=js"
export * from "./JWBOrderEntitiesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports